import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Star, BadgeCheck } from "lucide-react";
import { API } from "@/config/site";

const DEFAULT_REVIEWS = [
  {
    name: "Marcus T.",
    product: "Black Supreme Stealth Socks",
    text: "Came quick and the quality is insane - thick, soft, perfect fit. Already copped 2 more packs before the deal dies.",
  },
  {
    name: "Deja W.",
    product: "White Supreme Crew Socks",
    text: "Best socks I own. The email code made checkout feel legit and they look even better in person. 10/10.",
  },
];

export default function Reviews() {
  const [reviews, setReviews] = useState(DEFAULT_REVIEWS);

  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length) setReviews(r.data);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="reviews" className="relative bg-[#0A0A0A] py-20 md:py-32 border-t border-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono text-xs tracking-[0.35em] text-[#E60000] uppercase">
            Customers got theirs
          </p>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl mt-3 text-white">
            Word on the street
          </h2>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-testid="reviews-section">
          {reviews.map((r, i) => (
            <motion.figure
              key={`${r.name}-${i}`}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="relative bg-[#121212] border border-[#262626] hover:border-[#E60000]/60 transition-colors p-8 flex flex-col"
            >
              <div className="flex gap-1" data-testid={`review-stars-${i}`}>
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={18} className="fill-[#E60000] text-[#E60000]" />
                ))}
              </div>
              <blockquote className="font-mono text-sm md:text-base text-white leading-relaxed mt-6 flex-1">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-8 flex items-center justify-between border-t border-[#262626] pt-5">
                <div>
                  <p className="font-display uppercase text-lg text-white">{r.name}</p>
                  <p className="font-mono text-[10px] tracking-[0.15em] text-[#888] uppercase mt-1">
                    {r.product}
                  </p>
                </div>
                <span className="inline-flex items-center gap-1.5 font-mono text-[10px] tracking-[0.15em] text-[#E60000] uppercase">
                  <BadgeCheck size={14} /> Verified buyer
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
